import $ from "jquery"
import "./../tools/gmap.coffee"
import "slick-carousel"

# ==================================================
# > SWITCH
# ==================================================
class Switch
    constructor: (@$el) ->
        @state     = if @$el.hasClass "left-selected" then "left-selected" else "right-selected"
        @$wrapper  = @$el.prev ".switch-wrapper"
        @$el.click => @toggle()

    clearState: ->
        @$el.add(@$wrapper).removeClass @state

    setState: (state) ->
        @$el.add(@$wrapper).addClass state
        @state = state

    toggle: ->
        @clearState()

        if @state == "left-selected"
            @setState "right-selected"
        else
            @setState "left-selected"


$ ->

    # ==================================================
    # > MAP
    # ==================================================
    $(".switch-wrapper").each (i, el) ->
        if $(el).find(".map").length then $(el).gmap()


    # ==================================================
    # > SLIDE
    # ==================================================
    $(".images-slides").each ->
        if $(@).find("li.image").length > 1
            $(@).slick
                dots: !$(@).hasClass "nodots"


    # ==================================================
    # > SWITCH
    # ==================================================
    $(".switch").each (i, el) -> new Switch $(el)









// WEBPACK FOOTER //
// ./scripts/modules/slide-map-switch.coffee